module.exports = __webpack_public_path__ + "static/work_BD-3e6ad27a94b95450d8c1fe1d3e467fe8.mp4";